import React, { createContext, useState, useContext, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import axios from "axios";

import BroadcastNew from "./BroadcastNew";
import { toastSuccess, toastError } from "../../../shared/toastHelper";

const BroadcastNewContext = createContext();

export function useBroadcastNewContext() {
  return useContext(BroadcastNewContext);
}

const BroadcastNewProvider = (props) => {
  const {
    csrfToken,
    user,
    team,
    venueOwnerships,
    lastTouchedVenueOwnership,
  } = props;

  const requestedBroadcastType = typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("broadcast_type")
    : null;
  const initialBroadcastType = ["email", "sms", "push"].includes(requestedBroadcastType)
    ? requestedBroadcastType
    : "email";

  const [name, setName] = useState("");
  const [broadcastType, setBroadcastType] = useState(initialBroadcastType);
  const [transactional, setTransactional] = useState(false);
  const [selectedVenueOwnership, setSelectedVenueOwnership] = useState(lastTouchedVenueOwnership);

  const createBroadcast = (e) => {
    e.preventDefault();

    const payload = {
      name: name,
      venue_ownership_id: selectedVenueOwnership.id,
      transactional: transactional,
    };

    if (broadcastType === "sms") {
      payload.twilio_template_attributes = {
        team_id: team.id,
      };
    } else if (broadcastType === "email") {
      payload.beefree_template_attributes = {
        team_id: team.id,
      };
    }

    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post(`/teams/${team.id}/broadcasts`, {
      broadcast: payload,
    })
      .then((data) => {
        window.location.href = `/teams/${team.id}/broadcasts/${data["data"]["id"]}/edit`;
      })
      .catch((error) => {
        const messages = error?.response?.data;
        if (Array.isArray(messages) && messages.length > 0) {
          messages.forEach((message) => toastError(message));
        } else {
          toastError("Could not create broadcast, please try again");
        }
      });
  };

  const value = {
    csrfToken,
    user,
    team,
    venueOwnerships,
    selectedVenueOwnership,
    setSelectedVenueOwnership,
    name,
    setName,
    broadcastType,
    setBroadcastType,
    createBroadcast,
    transactional,
    setTransactional,
  };

  return (
    <BroadcastNewContext.Provider value={value}>
      {props.children}
    </BroadcastNewContext.Provider>
  );
};

const BroadcastNewContainer = (props) => (
  <BroadcastNewProvider {...props}>
    <ToastContainer icon={false} />
    <BroadcastNew />
  </BroadcastNewProvider>
);

export default BroadcastNewContainer;
